"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var FireWallRulesList_1 = require("./component/FireWallRulesList");
var FireWallRuleEditor_1 = require("./component/FireWallRuleEditor");
var PFireWallRulesList = /** @class */ (function (_super) {
    __extends(PFireWallRulesList, _super);
    function PFireWallRulesList(props) {
        return _super.call(this, props) || this;
    }
    PFireWallRulesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.brandsData.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AA = this.props.listFireWallActions.Subscribe("*", function (id, data) {
            _this.setState({ avail_actions: data.data });
        });
        //
        this.SID_AE = this.props.listFireWallEvents.Subscribe("*", function (id, data) {
            _this.setState({ avail_events: data.data });
        });
        this.SID_ATZ = this.props.listFireWallTrustZones.Subscribe("*", function (id, data) {
            _this.setState({ avail_trust_zones: data.data });
        });
        this.SID_AMT = this.props.listFireWallMessageTypes.Subscribe("*", function (id, data) {
            _this.setState({ avail_message_types: data.data });
        });
        this.SID_PP = this.props.listPProgramsAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_pprograms: data.data });
        });
        //
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_actions: [],
            avail_events: [],
            avail_trust_zones: [],
            avail_message_types: [],
            avail_pprograms: []
        }, function () {
            _this.props.brandsData.LoadData();
            _this.props.listFireWallActions.LoadData();
            _this.props.listFireWallEvents.LoadData();
            _this.props.listFireWallTrustZones.LoadDataAsCodeVal();
            _this.props.listFireWallMessageTypes.LoadData();
            _this.props.listPProgramsAvail.LoadData();
        });
    };
    PFireWallRulesList.prototype.componentWillUnmount = function () {
        this.props.brandsData.UnSubscribe(this.SID_AB);
        this.props.state.UnSubscribe(this.SID_STATE);
        this.props.listFireWallActions.UnSubscribe(this.SID_AA);
        this.props.listFireWallEvents.UnSubscribe(this.SID_AE);
        this.props.listFireWallTrustZones.UnSubscribe(this.SID_ATZ);
        this.props.listFireWallMessageTypes.UnSubscribe(this.SID_AMT);
        this.props.listPProgramsAvail.UnSubscribe(this.SID_PP);
    };
    PFireWallRulesList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PFireWallRulesList.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", record: val });
    };
    PFireWallRulesList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PFireWallRulesList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PFireWallRulesList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PFireWallRulesList.prototype.onCountryFilterChanged = function (allCountries, CountryId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllCountries(allCountries, true);
        }
        if (Action === "add") {
            this.props.state.addCountry(CountryId, true);
        }
        if (Action === "remove") {
            this.props.state.delCountry(CountryId, true);
        }
    };
    PFireWallRulesList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(FireWallRuleEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), availBrands: this.state.avail_brands, availActions: this.state.avail_actions, avail_events: this.state.avail_events, avail_trust_zones: this.state.avail_trust_zones, avail_message_types: this.state.avail_message_types, avail_pprograms: this.state.avail_pprograms, listPProgramPartnersAvail: this.props.listPProgramPartnersAvail }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(FireWallRuleEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), availBrands: this.state.avail_brands, availActions: this.state.avail_actions, avail_events: this.state.avail_events, avail_trust_zones: this.state.avail_trust_zones, avail_message_types: this.state.avail_message_types, avail_pprograms: this.state.avail_pprograms, listPProgramPartnersAvail: this.props.listPProgramPartnersAvail }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(FireWallRulesList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), availActionTypes: this.state.avail_actions, dlgSelectKeyVal: this.props.dlgSelectKeyVal }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PFireWallRulesList.prototype.render = function () {
        return this.getRenderObject();
    };
    PFireWallRulesList.getPageDescription = function (state) {
        return {
            icon: "shield-alt",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_security_firewall + "-id",
            itemTitle: "Файервол",
            route: routes_1.routes.page_security_firewall,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PFireWallRulesList;
}(React.Component));
exports.default = PFireWallRulesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/security_firewall/ui/PFireWallRulesList.tsx
// module id = 2547
// module chunks = 0